import { Block, Spacer, Video, Image } from "../../../../src/components/project/project";
import * as React from 'react';
export default {
  Block,
  Spacer,
  Video,
  Image,
  React
};